import { orgActBillingCount, orgActBillingData } from '../../../../../api/orgActAPI';
import { orgGuidBillingCount, orgGuidBillingData } from '../../../../../api/orgGuidAPI';
import errorHandle from '../../../../../utils/errorHandle';

export const fetchActBillingCount = async (setTotalCount, selectedStatus, selectedApproval, setLoading) => {
    try {
        const response = await orgActBillingCount(selectedStatus, selectedApproval);
        setTotalCount(response.data.billsCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActBillingsData = async (
    selectedStatus,
    selectedApproval,
    limit,
    offset,
    setBillingData,
    setLoading
) => {
    setLoading(true);
    try {
        const response = await orgActBillingData(selectedStatus, selectedApproval, limit, offset);
        setBillingData(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
